module.exports = __webpack_public_path__ + "static/media/lucia_vl.52d816cd.png";